/* eslint-disable no-unused-vars */
import { apolloClient } from "@/setup/apollo-setup";

import * as generic from "@/store/generic/mutations/result-status.js";
import { error } from '@/utils/notification';
import { log } from "@/utils/logs";

import {
    GET_STUDENT_PROFILE,
    GET_STUDENT_ENROLL,
    GET_STUDENT_ENROLLDETAILS,
    GET_STUDENT_BY_CURRENT_USER,
  UPDATE_STUDENT_INFORMATION,
} from '@/queries/modules/student/index.js';

import {
  BULKCREATE_STUDENTUNITLEARN,
  // ADD_STUDENT_UNIT_TOPIC_LEARN
} from "@/queries/modules/student-unit-learn/index.js";
import {getField, updateField} from "vuex-map-fields";

const state = {
  processing: false,
  error: null,
  success: null,
  profile: null,
  enroll: null,
  enrolldetails: [],
};

const getters = {
  getField
};

const mutations = {
  updateField,
  setError: generic.setError,
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: generic.setProcessing,
  setStudentProfile: (state, payload) => {
    state.profile = payload;
  },
  setStudentEnroll: function (state, payload) {
    log("MUTATION Student/setStudentEnroll:", payload);

    this.state.flatmap[payload.id] = payload;
    state.enroll = this.state.flatmap[payload.id];
  },
  setStudentEnrollDetails: function (state, studentEnrollDetails) {
    log("MUTATION Student/setStudentEnrollDetails:", studentEnrollDetails);

    state.enrolldetails = studentEnrollDetails.map(studentEnrollDetail => {
      this.state.flatmap[studentEnrollDetail.id] = studentEnrollDetail;
      return this.state.flatmap[studentEnrollDetail.id];
    });
  },
  removeStudentEnroll: (state, payload) => {
    state.enroll = null;
  },
  removeStudentEnrollDetails: (state, payload) => {
    state.enrolldetails = [];
  }
};

const actions = {


  async getStudent(context) {
    context.commit('setProcessing', true);
    try {
      const id = context.rootState.profile.id;
      const result = await apolloClient
      .query({
        query: GET_STUDENT_PROFILE,
        variables: {
          id: id
        },
        context: { clientName: 'Prisma2' }
      })
      const { data } = await result;

    // TODO: Handle after success;
    context.commit("setStudentProfile", data.getStudent);
    //   return { status: { success: true, error: false, message: "" }, data: [ ...data.getExams ] };

    } catch (e) {
      context.commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },

  async getStudentByCurrentUser(context) {
    context.commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_STUDENT_BY_CURRENT_USER,
          fetchPolicy: 'network-only',
          context: { clientName: 'Prisma2' }
        })
      const { data } = await result;

      // context.commit("setStudentProfile", data.getStudentByCurrentUser);

      return data.getStudentByCurrentUser;

    } catch (e) {
      context.commit('setError', error(e));
      return null;
    }
  },

  async getStudentById(context, payload) {
    context.commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_STUDENT_PROFILE,
          variables: payload,
          context: { clientName: 'Prisma2' }
        });

      const {data, errors} = await result;

      if (errors) {
        context.commit('setError', error(errors));
        return context.state.student;
      } else {
        context.commit('setStudent', data.getStudent);
        context.commit('setSuccess', null);
        return data.getStudent
      }

    } catch (e) {
      context.commit('setError', error(e));
      return {status: {success: false, error: true, message: "", full: e}};
    }
  },

  async getStudentEnroll(context) {
    context.commit('setProcessing', true);

    try {

      const id = context.state.profile.student.id;

      const result = await apolloClient
      .query({
        query: GET_STUDENT_ENROLL,
        variables: {
          id: id
        },
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      })
      const { data } = await result;


      context.commit("setStudentEnroll", data.getStudentEnrollsByStudentId[0]);

      const studentEnroll = data.getStudentEnrollsByStudentId[0];
      const studentEnrollDetails = studentEnroll.studentEnrollDetails;

      context.commit("setStudentEnrollDetails", studentEnrollDetails);

    } catch (e) {
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },

  async getStudentEnrollDetailsByStudentEnrollId(context) {
    context.commit('setProcessing', true);
    try {
      const id = context.rootState.profile.id;
      const result = await apolloClient
      .query({
        query: GET_STUDENT_ENROLLDETAILS,
        variables: {
          id: id
        },
        fetchPolicy: "network-only",
        context: { clientName: 'Prisma2' }
      })
      const { data } = await result;

    // TODO: Handle after success;
      context.commit("setStudentEnrollDetails", data.getStudentEnrollDetailsByStudentEnrollId);
    //   return { status: { success: true, error: false, message: "" }, data: [ ...data.getExams ] };

    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },

/**
  *  Action to Check Student Unit Learn and Create if not exist.
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

  async checkStudentUnitLearn(context, params) {
    const { mode = "check-only", studentEnrollDetail } = params;
    // console.log(params);

    context.commit('setProcessing', true);
    try {
      let studentUnitLearnCreateSets = new Array();
      let bulkCreateStudentUnitLearnSets = "[]";

      // if (mode === "check-only") {
      //   for (let studentEnrollDetail of studentEnrollDetails) {
      //     const { studentUnitLearns } = studentEnrollDetail;
      //   }
      // }

      if (mode === "check-then-create") {
        // console.log("Check then create");
        // for (let studentEnrollDetail of studentEnrollDetails) {
          const { studentUnitLearns } = studentEnrollDetail;
          const { courseOutline } = studentEnrollDetail.courseOutlineRegistration;
          const { courseOutlineUnits, vdoSets } = courseOutline;
          const { vdoSetUnits } = vdoSets[0];

          if (
            studentUnitLearns.length < courseOutlineUnits.length
          ) {
            // Create Student Unit Learn;
            let createPayload = {

            };

            // let lackingSequenceList = [];
            // let courseOutlineUnitSequenceList = [];

            for (let courseOutlineUnit of courseOutlineUnits) {

              if (!Object.prototype.hasOwnProperty.call(createPayload, courseOutlineUnit.seq)) {
                createPayload[courseOutlineUnit.seq] = {};
              }

              createPayload[courseOutlineUnit.seq].courseOutlineUnitId = courseOutlineUnit.id;

              createPayload[courseOutlineUnit.seq].studentEnrollDetailId = studentEnrollDetail.id;

              createPayload[courseOutlineUnit.seq].studentEnrollId = studentEnrollDetail.studentEnroll.id;

              createPayload[courseOutlineUnit.seq].unitSeq = courseOutlineUnit.seq;

              createPayload[courseOutlineUnit.seq].totalVdoLength = 0;

              createPayload[courseOutlineUnit.seq].totalLearnTime = 0;

              createPayload[courseOutlineUnit.seq].learnPercent = 0;
            }

            for (let vdoSetUnit of vdoSetUnits) {
              if (vdoSetUnit.id) {
                createPayload[vdoSetUnit.unitSeq].vdoSetUnitId = vdoSetUnit.id;
                createPayload[vdoSetUnit.unitSeq].totalVdoLength = vdoSetUnit.totalVdoLength;
              }
            }

            // let studentUnitLearnAvailableSequence = [];
            for (let studentUnitLearn of studentUnitLearns) {
              if (Object.prototype.hasOwnProperty.call(createPayload, studentUnitLearn.unitSeq)) {
                if (createPayload[studentUnitLearn.unitSeq].courseOutlineUnitId) {
                  // console.log(studentUnitLearn.courseOutlineUnit.id, createPayload[studentUnitLearn.unitSeq].courseOutlineUnit.courseOutlineUnit.id);
                  // console.log(studentUnitLearn);
                  if (studentUnitLearn.courseOutlineUnit.id === createPayload[studentUnitLearn.unitSeq].courseOutlineUnitId) {
                    // console.log(createPayload[studentUnitLearn.unitSeq]);
                    delete createPayload[studentUnitLearn.unitSeq];
                  }
                }
              }
              // studentUnitLearnAvailableSequence.push(studentUnitLearn.unitSeq);
              // if (!courseOutlineUnitSequenceList.includes(studentUnitLearn.unitSeq)) {
              //   lackingSequenceList.push(studentUnitLearn.unitSeq);
              // }
            }
            studentUnitLearnCreateSets.push(createPayload);
            bulkCreateStudentUnitLearnSets = JSON.stringify(studentUnitLearnCreateSets);
          }

          // Bulk Creating Student Unit Learn records.
          // console.log("ACTION: checkStudentUnitLearn => Bulk Creating Student Unit Learn")

          const result = await apolloClient
          .mutate({
            mutation: BULKCREATE_STUDENTUNITLEARN,
            variables: {
              bulkCreateStudentUnitLearnSets
            },
            context: { clientName: 'Prisma2' }
          });

          const { data } = result;

          if (data) {
            return data.bulkCreateStudentUnitLearn;
          }
          return [];

        // }
      }

    } catch (e) {
      // console.log(e);
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },

  async bulkCreateStudentUnitLearn(context, studentEnrollDetails) {
    // console.log("bulkCreateStudentUnitLearn", studentEnrollDetails.length);
    context.commit('setProcessing', true);
    try {
      let bulkCreateStudentUnitLearnSets = "[]";

      const result = await apolloClient
      .mutate({
        mutation: BULKCREATE_STUDENTUNITLEARN,
        variables: {
          bulkCreateStudentUnitLearnSets
        },
        context: { clientName: 'Prisma2' }
      })

      const { data } = await result;
      // console.log(result);
      return data

    } catch (e) {
      // console.log(e);
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },

  async updateStudentInformation(context, payload) {
    context.commit('setProcessing', true);
    try {
      const result = await apolloClient
        .mutate({
          mutation: UPDATE_STUDENT_INFORMATION,
          variables: payload,
          context: { clientName: 'Prisma2' }
        });

      const {data, errors} = await result;

      context.commit('false', true);
      if (errors) {
        context.commit('setError', error(errors));
        return null;
      } else {
        return data.updateStudentInformation
      }

    } catch (e) {
      context.commit('setError', error(e));
      return null;
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
